export interface DerivedObservedAt {
  observedAt: number;
}

function validLocalDate(parts: readonly number[]): number | null {
  const [year, month, day, hour, minute, second] = parts;
  if (year === undefined || month === undefined || day === undefined || hour === undefined || minute === undefined || second === undefined) return null;
  const date = new Date(year, month - 1, day, hour, minute, second, 0);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day || date.getHours() !== hour || date.getMinutes() !== minute || date.getSeconds() !== second) return null;
  return date.getTime();
}

export function parseScreenshotFilenameTime(fileName: string): number | null {
  const separated = /(20\d{2})[-_](\d{2})[-_](\d{2})[^\d]+(\d{2})[-_:](\d{2})[-_:](\d{2})/u.exec(fileName);
  if (separated) return validLocalDate(separated.slice(1).map(Number));
  const compact = /(20\d{2})(\d{2})(\d{2})[^\d]?(\d{2})(\d{2})(\d{2})/u.exec(fileName);
  if (compact) return validLocalDate(compact.slice(1).map(Number));
  return null;
}

/** Derive one immutable observation time without recording import mechanism. */
export function deriveObservedAt(file: File, fallbackAt = Date.now()): DerivedObservedAt {
  const fromName = parseScreenshotFilenameTime(file.name);
  if (fromName !== null) return { observedAt: fromName };
  if (Number.isFinite(file.lastModified) && file.lastModified > 0) {
    return { observedAt: file.lastModified };
  }
  return { observedAt: fallbackAt };
}
